import React from 'react';
import {Box, Typography, Skeleton, Grid} from '@mui/material';
import {formatDateTime} from "../utils/utils";
import {Udalost} from "../api/JsdhNotifikaceService/generated";

interface StatistikyOdpovediProps {
    pocetJedu: number;
    pocetNejedu: number;
    pocetVD: number;
    pocetS: number;
    pocetH: number;
    isLoading: boolean;
    aktivniPoplach?: Udalost;
    showDatumCasVyhlaseni?: boolean;
}

const StatistikyOdpovedi: React.FC<StatistikyOdpovediProps> = ({
                                                                   pocetJedu,
                                                                   pocetNejedu,
                                                                   pocetVD,
                                                                   pocetS,
                                                                   pocetH,
                                                                   isLoading,
                                                                   aktivniPoplach,
                                                                   showDatumCasVyhlaseni = false,
                                                               }) => {
    if (isLoading) {
        return (
            <Grid container spacing={2} alignItems="center" justifyContent="center">
                {/* Levý sloupec – Role skeleton */}
                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <Box display="flex" flexDirection={{ xs: 'row', md: 'column' }} flexWrap="wrap" gap={1} justifyContent={{ xs: 'center', md: 'flex-start' }}>
                        {[1, 2, 3].map((i) => (
                            <Skeleton
                                key={i}
                                variant="rounded"
                                sx={{
                                    width: 'var(--dashboard-role-box-width)',
                                    height: 'var(--dashboard-role-box-height)',
                                    borderRadius: 2,
                                }}
                            />
                        ))}
                    </Box>
                </Grid>

                {/* Střední sloupec – JEDU / NEJEDU skeleton */}
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 5 }}>
                    <Box display="flex" gap={{ xs: 2, md: 4, lg: 5 }} justifyContent="center" flexWrap="nowrap">
                        <Skeleton
                            variant="rounded"
                            sx={{
                                width: 'var(--dashboard-stats-box-width)',
                                height: 'var(--dashboard-stats-box-height)',
                                borderRadius: 4,
                            }}
                        />
                        <Skeleton
                            variant="rounded"
                            sx={{
                                width: 'var(--dashboard-stats-box-width)',
                                height: 'var(--dashboard-stats-box-height)',
                                borderRadius: 4,
                            }}
                        />
                    </Box>
                </Grid>

                {/* Pravý sloupec – Čas vyhlášení skeleton */}
                <Grid size={{ xs: 12, md: 3 }} display="flex" justifyContent={{ xs: 'center', md: 'flex-end' }}>
                    <Skeleton
                        variant="rounded"
                        sx={{
                            width: { xs: '100%', sm: 160, md: 180 },
                            height: 'var(--dashboard-stats-box-height)',
                            borderRadius: 4,
                        }}
                    />
                </Grid>
            </Grid>
        );
    }

    return (

        <Grid container spacing={2} alignItems="center" justifyContent="center">
            {/* Levý sloupec – Role */}
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Box display="flex" flexDirection={{ xs: 'row', md: 'column' }} flexWrap="wrap" gap={1} justifyContent={{ xs: 'center', md: 'flex-start' }}>
                    {[
                        { label: 'Velitel družstva', count: pocetVD },
                        { label: 'Strojník', count: pocetS },
                        { label: 'Hasič', count: pocetH }
                    ].map((item) => (
                        <Box
                            key={item.label}
                            sx={{
                                width: 'var(--dashboard-role-box-width)',
                                height: 'var(--dashboard-role-box-height)',
                                borderRadius: 2,
                                backgroundColor: 'action.hover',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                px: 1.5,
                                border: 1,
                                borderColor: 'divider',
                                boxShadow: 1,
                            }}
                        >
                            <Typography fontWeight="bold" sx={{ fontSize: 'calc(var(--dashboard-role-box-height) * 0.38)', lineHeight: 1, whiteSpace: 'nowrap' }}>
                                {item.label}:
                            </Typography>
                            <Typography fontWeight="bold" sx={{ fontSize: 'calc(var(--dashboard-role-box-height) * 0.55)', lineHeight: 1 }} color="primary.main">
                                {item.count}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Grid>

            {/* Střední sloupec – JEDU / NEJEDU */}
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 5 }}>
                <Box display="flex" gap={{ xs: 2, md: 4, lg: 5 }} justifyContent="center" flexWrap="nowrap">
                    {/* JEDU */}
                    <Box
                        sx={{
                            width: 'var(--dashboard-stats-box-width)',
                            height: 'var(--dashboard-stats-box-height)',
                            borderRadius: 4,
                            backgroundColor: 'success.main',
                            color: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography fontWeight="bold" sx={{ fontSize: 'var(--dashboard-stats-label)' }}>
                            JEDU
                        </Typography>
                        <Typography fontWeight="bold" sx={{ fontSize: 'var(--dashboard-stats-number)', lineHeight: 1 }}>
                            {pocetJedu}
                        </Typography>
                    </Box>

                    {/* NEJEDU */}
                    <Box
                        sx={{
                            width: 'var(--dashboard-stats-box-width)',
                            height: 'var(--dashboard-stats-box-height)',
                            borderRadius: 4,
                            backgroundColor: 'error.main',
                            color: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography fontWeight="bold" sx={{ fontSize: 'var(--dashboard-stats-label)' }}>
                            NEJEDU
                        </Typography>
                        <Typography fontWeight="bold" sx={{ fontSize: 'var(--dashboard-stats-number)', lineHeight: 1 }}>
                            {pocetNejedu}
                        </Typography>
                    </Box>
                </Box>
            </Grid>

            {/* Pravý sloupec – Čas vyhlášení (vždy renderovat kvůli zachování layoutu) */}
            <Grid size={{ xs: 12, md: 3 }} display="flex" justifyContent={{ xs: 'center', md: 'flex-end' }}
                  sx={{ visibility: showDatumCasVyhlaseni && aktivniPoplach?.casVyhlaseni ? 'visible' : 'hidden' }}
            >
                <Box
                    sx={{
                        minWidth: 'fit-content',
                        height: 'var(--dashboard-stats-box-height)',
                        borderRadius: 4,
                        backgroundColor: 'action.hover',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        px: { xs: 2, md: 3 },
                    }}
                >
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, whiteSpace: 'nowrap', fontSize: 'var(--dashboard-stats-label)' }}>
                        <strong>Čas vyhlášení:</strong>
                    </Typography>
                    <Typography fontWeight="bold" sx={{ fontSize: '1.3rem', lineHeight: 1, whiteSpace: 'nowrap' }}>
                        {aktivniPoplach?.casVyhlaseni ? formatDateTime(aktivniPoplach.casVyhlaseni) : '\u00A0'}
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    );
};

export default StatistikyOdpovedi;
